# I'd like to call this .fadeOut, but jQuery already stole that name
$.fn.removeWithFade = ->
  if $.support.transition
    # 150 is the maximum number of ms to wait for the transition to finish
    @.removeClass("in").one($.support.transition.end, => @.remove()).emulateTransitionEnd(300)
  else
    @.remove()
